import { TextColumn } from "@portal/BaseComponents/Table/Components/Text/TextColumn";

import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { PaymentList } from "@portal/types/entities/payment";
import { CellRenderProps } from "@sinecycle/growcomponents";
import { useParams } from "react-router-dom";

function ReferenceCell(props: CellRenderProps<PaymentList>) {
  const { data } = props;

  const { customer_id } = useParams<AppPageParams>();
  const navigate = usePageNavigate();
  function handleQueryParams() {
    navigate({
      appPage: "PAYMENT_DETAILS",
      pathParams: {
        customer_id: customer_id as string,
        payment_id: data?.id as string,
      },
    });
  }

  if (!data) return;
  return (
    <TextColumn
      type="Text"
      text={data.reference_no ? data.reference_no : "-"}
      textProps={{
        strong: true,
        onClick: handleQueryParams,
        ellipsis: { tooltip: data.reference_no },
        style: {
          color: "var(--primary-7)",

          cursor: "pointer",
        },
      }}
    />
  );
}

export { ReferenceCell };
